export default {
  400: 'http.badRequest',
  201: 'http.created',
  204: 'http.deleted',
  500: 'http.internalError',
  404: 'http.notFound',
  200: 'http.ok',
  401: 'http.unauthorized',
  422: 'http.unprocessableEntity',
  501: 'http.notImplemented',
  503: 'http.serviceUnavailable',
}



// WEBPACK FOOTER //
// ./src/utils/http-status-map.ts